export interface Room {
  id: string;
  name: string;
  nameEn: string;
  category: string;
  size: string;
  bedType: string;
  price: string;
  description: string;
  features: string[];
  imageUrl: string;
}

export interface Restaurant {
  id: string;
  name: string;
  nameEn: string;
  category: string;
  cuisine: string;
  rating: string;
  description: string;
  hours: string;
  location: string;
  imageUrl: string;
}

export interface Facility {
  id: string;
  name: string;
  icon: string;
  description: string;
}

export interface Article {
  id: string;
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  date: string;
  author: string;
  imageUrl: string;
  tags: string[];
}

export interface Review {
  id: string;
  name: string;
  platform: string;
  rating: number;
  date: string;
  content: string;
}

export const rooms: Room[] = [
  {
    id: 'deluxe-king',
    name: '豪华大床房',
    nameEn: 'Deluxe King Room',
    category: '豪华客房',
    size: '42㎡',
    bedType: '特大床',
    price: 'HK$2,800起/晚',
    description: '宽敞舒适的豪华大床房，配备顶级寝具与先进智能控制系统，落地窗尽览澳门城市天际线，让您在繁华都市中享受静谧与奢华。',
    features: ['智能控制系统', '独立浴缸', 'Nespresso咖啡机', '55寸4K电视', '高速Wi-Fi', '迷你吧'],
    imageUrl: 'https://readdy.ai/api/search-image?query=luxury%20hotel%20deluxe%20king%20bedroom%20interior%20with%20floor%20to%20ceiling%20windows%20overlooking%20macau%20city%20skyline%20warm%20golden%20lighting%20elegant%20marble%20bathroom%20modern%20furniture%20plush%20bedding%20cream%20beige%20tones&width=800&height=600&seq=room-deluxe-king&orientation=landscape',
  },
  {
    id: 'premier-suite',
    name: '尊贵套房',
    nameEn: 'Premier Suite',
    category: '套房',
    size: '78㎡',
    bedType: '特大床',
    price: 'HK$5,800起/晚',
    description: '尊贵套房拥有独立客厅与卧室的完美布局，融合东方典雅与西方奢华设计，私人管家服务为您打造无微不至的入住体验。',
    features: ['私人管家服务', '独立客厅', '步入式衣帽间', '双洗手台', '行政酒廊使用权', '欢迎香槟'],
    imageUrl: 'https://readdy.ai/api/search-image?query=luxury%20hotel%20premier%20suite%20spacious%20living%20room%20with%20separate%20bedroom%20elegant%20interior%20design%20warm%20gold%20and%20cream%20tones%20marble%20floors%20chandelier%20macau%20view%20through%20panoramic%20windows%20sophisticated%20luxury&width=800&height=600&seq=room-premier-suite&orientation=landscape',
  },
  {
    id: 'presidential-suite',
    name: '总统套房',
    nameEn: 'Presidential Suite',
    category: '套房',
    size: '180㎡',
    bedType: '特大床',
    price: 'HK$28,800起/晚',
    description: '澳门最顶级的总统套房，占据酒店最高楼层，拥有360度全景视野。配备私人影院、专属SPA房与独立用餐区，极致奢华不容错过。',
    features: ['私人管家团队', '私人影院', '专属SPA房', '独立用餐区', '直升机接送', '劳斯莱斯专车'],
    imageUrl: 'https://readdy.ai/api/search-image?query=ultimate%20luxury%20presidential%20suite%20penthouse%20level%20panoramic%20macau%20views%20grand%20chandelier%20private%20dining%20room%20marble%20everywhere%20gold%20accents%20plush%20velvet%20furniture%20sophisticated%20elegant%20interior%20design&width=800&height=600&seq=room-presidential-suite&orientation=landscape',
  },
  {
    id: 'family-suite',
    name: '家庭套房',
    nameEn: 'Family Suite',
    category: '套房',
    size: '65㎡',
    bedType: '特大床+双床',
    price: 'HK$4,200起/晚',
    description: '专为家庭出行设计的温馨套房，配备儿童专属区域与亲子设施，让全家人在澳门享受欢乐舒适的度假时光。',
    features: ['儿童专属区域', '亲子设施', '游戏机', '儿童洗漱用品', '连通房可选', '婴儿床服务'],
    imageUrl: 'https://readdy.ai/api/search-image?query=family%20friendly%20luxury%20hotel%20suite%20warm%20inviting%20atmosphere%20kids%20play%20corner%20colorful%20yet%20elegant%20decor%20separate%20sleeping%20areas%20soft%20lighting%20comfortable%20spacious%20interior%20cream%20and%20gold%20tones&width=800&height=600&seq=room-family-suite&orientation=landscape',
  },
  {
    id: 'executive-room',
    name: '行政客房',
    nameEn: 'Executive Room',
    category: '豪华客房',
    size: '38㎡',
    bedType: '大床/双床',
    price: 'HK$2,200起/晚',
    description: '高效舒适的行政客房，配备完善商务设施与行政楼层专属礼遇，是商务旅客的理想之选。',
    features: ['行政楼层礼遇', '办公区域', '高速网络', '行政酒廊', '免费熨烫', '延迟退房'],
    imageUrl: 'https://readdy.ai/api/search-image?query=modern%20executive%20hotel%20room%20business%20traveler%20focused%20clean%20sleek%20design%20work%20desk%20ergonomic%20chair%20warm%20neutral%20tones%20city%20view%20window%20efficient%20layout%20premium%20comfort%20cream%20beige%20interior&width=800&height=600&seq=room-executive-room&orientation=landscape',
  },
  {
    id: 'grand-deluxe-suite',
    name: '豪华海景套房',
    nameEn: 'Grand Deluxe Ocean Suite',
    category: '套房',
    size: '95㎡',
    bedType: '特大床',
    price: 'HK$8,800起/晚',
    description: '坐拥无敌海景的豪华套房，在宽敞的私人露台上品味澳门海天一色的壮丽景观，感受独一无二的奢华海滨生活。',
    features: ['私人海景露台', '独立书房', '按摩浴缸', '私人吧台', '管家服务', '优先餐厅预订'],
    imageUrl: 'https://readdy.ai/api/search-image?query=luxury%20ocean%20view%20suite%20private%20terrace%20overlooking%20macau%20coastline%20and%20sea%20spectacular%20sunset%20view%20elegant%20interior%20warm%20golden%20hour%20lighting%20marble%20details%20sophisticated%20comfort%20cream%20beige%20gold%20decor&width=800&height=600&seq=room-grand-deluxe-suite&orientation=landscape',
  },
];

export const restaurants: Restaurant[] = [
  {
    id: 'robuchon-au-dome',
    name: '天巢法国餐厅',
    nameEn: 'Robuchon au Dôme',
    category: '米其林三星',
    cuisine: '法餐',
    rating: '米其林三星',
    description: '位于酒店最高层的天巢法国餐厅，由传奇名厨Joël Robuchon打造，提供最顶级的法式fine dining体验。穹顶之下，璀璨水晶灯与澳门全景交相辉映。',
    hours: '12:00-14:30, 18:30-22:30',
    location: '酒店43楼',
    imageUrl: 'https://readdy.ai/api/search-image?query=elegant%20michelin%20three%20star%20french%20restaurant%20interior%20grand%20crystal%20chandelier%20domed%20ceiling%20panoramic%20city%20views%20through%20curved%20windows%20white%20tablecloths%20fine%20dining%20atmosphere%20warm%20ambient%20lighting%20luxurious%20gold%20cream%20tones&width=800&height=600&seq=dining-robuchon&orientation=landscape',
  },
  {
    id: 'the-eight',
    name: '8餐厅',
    nameEn: 'The Eight',
    category: '米其林三星',
    cuisine: '粤菜',
    rating: '米其林三星',
    description: '澳门唯一连续多年荣获米其林三星的中餐厅，以精湛粤菜技艺与创新菜品闻名，金鱼主题装饰营造出独特的东方雅韵。',
    hours: '11:30-14:30, 18:00-22:30',
    location: '酒店2楼',
    imageUrl: 'https://readdy.ai/api/search-image?query=luxury%20cantonese%20restaurant%20michelin%20three%20star%20elegant%20chinese%20interior%20gold%20fish%20motif%20dark%20wood%20panels%20red%20and%20gold%20accents%20ambient%20lighting%20sophisticated%20traditional%20meets%20modern%20design&width=800&height=600&seq=dining-the-eight&orientation=landscape',
  },
  {
    id: 'buffet-grand',
    name: '新葡京自助餐',
    nameEn: 'Grand Lisboa Buffet',
    category: '自助餐',
    cuisine: '国际美食',
    rating: '人气推荐',
    description: '汇聚全球美食的自助餐厅，从新鲜海鲜到精致甜点，超过200道菜品任您挑选，是澳门最受欢迎的自助餐之一。',
    hours: '07:00-10:30, 12:00-14:30, 18:00-22:00',
    location: '酒店3楼',
    imageUrl: 'https://readdy.ai/api/search-image?query=grand%20international%20buffet%20restaurant%20luxurious%20setting%20fresh%20seafood%20display%20dessert%20station%20elegant%20food%20presentation%20warm%20lighting%20cream%20gold%20interior%20lively%20yet%20sophisticated%20atmosphere&width=800&height=600&seq=dining-buffet&orientation=landscape',
  },
];

export const facilities: Facility[] = [
  { id: 'spa', name: '水疗中心', icon: 'ri-mental-health-line', description: '荣获国际大奖的奢华水疗中心，融合东方养生智慧与西方理疗科技，提供全方位的放松与焕新体验。' },
  { id: 'pool', name: '恒温泳池', icon: 'ri-water-flash-line', description: '室内恒温无边泳池，配备水中吧台与按摩池，让您在畅游的同时尽览澳门城市天际线。' },
  { id: 'gym', name: '健身中心', icon: 'ri-heart-pulse-line', description: '24小时开放的先进健身中心，配备Technogym顶级器材与私人教练服务，满足您的全方位运动需求。' },
  { id: 'casino', name: '娱乐场', icon: 'ri-vip-diamond-line', description: '澳门最大的娱乐场之一，提供丰富多样的博彩娱乐项目与VIP专属贵宾厅服务。' },
  { id: 'conference', name: '会议中心', icon: 'ri-building-2-line', description: '超过3,000平方米的多功能会议空间，配备尖端视听设备与专业会务团队，是商务活动的理想场所。' },
  { id: 'shopping', name: '购物廊', icon: 'ri-shopping-bag-3-line', description: '汇集国际奢侈品牌的精品购物廊，从高级珠宝到设计师时装，一站式满足您的购物需求。' },
];

export const articles: Article[] = [
  {
    id: 'a1',
    slug: 'xin-pu-jing-ru-zhu-gong-lue',
    title: '新葡京酒店入住全攻略：从预订到退房的完美体验',
    excerpt: '详细解读新葡京酒店的预订流程、入住手续、客房设施使用指南及退房注意事项，让您的澳门之旅从入住开始就尽享尊贵。',
    content: `<p>作为澳门最具代表性的地标酒店之一，新葡京酒店以其独特的莲花造型和金色的外观成为澳门天际线上最引人注目的存在。本文将为您详尽介绍从预订到退房的每一个环节，确保您拥有完美的入住体验。</p>
    <h2>一、预订方式选择</h2>
    <p>新葡京酒店提供多种预订渠道：官方网站直接预订可享受最优价格保证和专属礼遇；通过旅行平台预订可获得套餐优惠；电话预订则适合有特殊需求的宾客。建议提前至少两周预订，尤其是节假日和旺季期间。</p>
    <h2>二、房型选择建议</h2>
    <p>豪华大床房适合商务旅客和情侣出行，空间舒适且价格合理；尊贵套房适合追求品质的度假旅客；总统套房则为追求极致体验的宾客而设。家庭出游推荐家庭套房，配备完善的亲子设施。</p>
    <h2>三、入住流程</h2>
    <p>抵达酒店后，专属礼宾人员将为您办理入住手续。新葡京酒店提供24小时前台服务，入住时间为下午3点，退房时间为中午12点。行政楼层宾客可享受专属入住通道和行政酒廊礼遇。</p>`,
    category: '入住攻略',
    date: '2026-08-01',
    author: '新葡京酒店礼宾部',
    imageUrl: 'https://readdy.ai/api/search-image?query=grand%20lisboa%20hotel%20macau%20iconic%20golden%20lotus%20shaped%20building%20exterior%20luxury%20entrance%20with%20rolls%20royce%20parked%20elegant%20doorman%20welcoming%20guests%20warm%20sunset%20lighting&width=800&height=600&seq=article-a1&orientation=landscape',
    tags: ['入住攻略', '预订指南', '房型选择'],
  },
  {
    id: 'a2',
    slug: 'xin-pu-jing-can-ting-zhi-nan',
    title: '舌尖上的新葡京：米其林星级餐厅全解析',
    excerpt: '深入探访新葡京酒店内多家米其林星级餐厅，从天巢法国餐厅到8餐厅，带您领略澳门顶级美食的非凡魅力。',
    content: `<p>新葡京酒店是澳门拥有最多米其林星级的酒店之一，汇聚了法餐、粤菜和国际美食的顶级餐饮体验。无论您是美食爱好者还是寻求特别用餐体验的旅客，这里都能满足您的味蕾。</p>
    <h2>天巢法国餐厅 — 米其林三星</h2>
    <p>位于酒店43楼的天巢法国餐厅是澳门餐饮界的传奇。由已故名厨Joël Robuchon打造，这家餐厅以其精湛的法式料理和令人叹为观止的穹顶设计闻名。推荐品尝招牌菜鱼子酱帝王蟹塔和慢煮和牛，人均消费约HK$2,500起。</p>
    <h2>8餐厅 — 米其林三星</h2>
    <p>8餐厅是澳门唯一连续多年获得米其林三星的中餐厅，以精致粤菜和创新菜品著称。金鱼主题的装潢设计独具匠心，招牌菜包括黑松露鲍鱼酥和脆皮烧鹅，人均消费约HK$1,500起。</p>
    <h2>新葡京自助餐</h2>
    <p>汇聚全球美食的自助餐厅，提供超过200道菜品。海鲜区的新鲜龙虾和生蚝是最大亮点，甜品区的法式甜点同样不容错过。午餐人均HK$388，晚餐人均HK$588。</p>`,
    category: '餐厅美食',
    date: '2026-07-25',
    author: '新葡京酒店餐饮部',
    imageUrl: 'https://readdy.ai/api/search-image?query=elegant%20fine%20dining%20table%20setting%20michelin%20star%20restaurant%20with%20artistic%20food%20plating%20crystal%20glassware%20warm%20candlelight%20sophisticated%20ambiance%20gold%20cream%20tones%20gourmet%20cuisine%20presentation&width=800&height=600&seq=article-a2&orientation=landscape',
    tags: ['餐厅', '米其林', '美食攻略'],
  },
  {
    id: 'a3',
    slug: 'xin-pu-jing-zhou-bian-jing-dian',
    title: '新葡京酒店周边必游景点：步行可达的澳门精华',
    excerpt: '以新葡京酒店为起点，步行即可探索澳门最具代表性的历史遗迹、购物中心和娱乐场所，这篇攻略帮您规划完美行程。',
    content: `<p>新葡京酒店地处澳门半岛核心地段，周边汇聚了澳门最精华的旅游景点和文化地标。以酒店为中心，步行30分钟内即可到达以下热门景点。</p>
    <h2>大三巴牌坊（步行15分钟）</h2>
    <p>澳门最著名的地标性建筑，原为圣保禄教堂的前壁遗址。这座巴洛克风格的石刻建筑是澳门世界遗产的核心组成部分，周围街区遍布手信店和特色小吃。</p>
    <h2>议事亭前地（步行12分钟）</h2>
    <p>澳门最具代表性的广场之一，波浪形碎石路面环绕着色彩斑斓的葡式建筑。这里是购物和品尝地道美食的绝佳起点。</p>
    <h2>澳门旅游塔（车程10分钟）</h2>
    <p>338米高的澳门旅游塔提供惊险刺激的高空漫步和蹦极体验，观景台可360度俯瞰澳门全景，是拍照打卡的必到之处。</p>`,
    category: '周边交通',
    date: '2026-07-18',
    author: '新葡京酒店礼宾部',
    imageUrl: 'https://readdy.ai/api/search-image?query=macau%20historic%20ruins%20of%20st%20paul%20facade%20sunny%20day%20with%20tourists%20walking%20around%20portuguese%20style%20cobblestone%20streets%20colorful%20buildings%20blue%20sky%20warm%20tones%20travel%20photography&width=800&height=600&seq=article-a3&orientation=landscape',
    tags: ['周边景点', '旅游攻略', '澳门'],
  },
  {
    id: 'a4',
    slug: 'xin-pu-jing-hao-hua-tao-fang-tui-jian',
    title: '奢华之选：新葡京酒店套房全方位对比评测',
    excerpt: '从尊贵套房到总统套房，我们实地探访新葡京酒店多款豪华套房，从空间、设施、景观、服务四大维度进行全面对比。',
    content: `<p>新葡京酒店的套房系列代表着澳门酒店业的最高水准。本文将从空间布局、设施配置、景观视野和专属服务四大维度，为您全面对比各款套房的特色与优势。</p>
    <h2>尊贵套房 — 性价比之选</h2>
    <p>78平方米的尊贵套房拥有独立的客厅与卧室区域，配备步入式衣帽间和双洗手台。行政酒廊使用权为商务旅客提供了极大便利。</p>
    <h2>豪华海景套房 — 景观最佳</h2>
    <p>95平方米的豪华海景套房拥有令人惊叹的私人海景露台，是欣赏澳门海天一色景观的最佳选择。独立书房和按摩浴缸更添舒适。</p>
    <h2>总统套房 — 极致奢华</h2>
    <p>180平方米的总统套房占据酒店最高楼层，配备私人影院、专属SPA房和独立用餐区，直升机接送和劳斯莱斯专车服务将奢华体验推向极致。</p>`,
    category: '房型选择',
    date: '2026-07-10',
    author: '新葡京酒店客房部',
    imageUrl: 'https://readdy.ai/api/search-image?query=spacious%20luxury%20hotel%20suite%20living%20area%20with%20panoramic%20floor%20to%20ceiling%20windows%20marble%20flooring%20designer%20furniture%20soft%20cream%20gold%20tones%20elegant%20chandelier%20sophisticated%20interior%20design%20magazine%20worthy&width=800&height=600&seq=article-a4&orientation=landscape',
    tags: ['套房', '房型对比', '奢华体验'],
  },
  {
    id: 'a5',
    slug: 'ao-men-xin-pu-jing-jiao-tong-zhi-nan',
    title: '澳门交通全攻略：如何从各口岸抵达新葡京酒店',
    excerpt: '详细介绍从澳门国际机场、港澳码头、关闸口岸和横琴口岸前往新葡京酒店的交通方式，包括免费穿梭巴士时刻表。',
    content: `<p>新葡京酒店位于澳门半岛中心地带，交通极为便利。无论您从哪个口岸入境澳门，都能轻松抵达酒店。本文为您整理最全面的交通指南。</p>
    <h2>澳门国际机场出发</h2>
    <p>距离酒店约8公里，车程约15分钟。酒店提供免费穿梭巴士服务，每30分钟一班。出租车费用约HK$80-100。</p>
    <h2>港澳码头出发</h2>
    <p>距离酒店约3公里，车程约8分钟。酒店免费穿梭巴士每20分钟一班。您也可以选择乘坐公交车3A、10A路线。</p>
    <h2>关闸口岸出发</h2>
    <p>距离酒店约5公里，车程约12分钟。有多条公交线路直达，也可乘坐酒店穿梭巴士（需提前预约）。</p>
    <h2>横琴口岸出发</h2>
    <p>距离酒店约15公里，车程约25分钟。建议乘坐出租车或预约酒店接机服务，费用约HK$150-200。</p>`,
    category: '周边交通',
    date: '2026-07-05',
    author: '新葡京酒店交通部',
    imageUrl: 'https://readdy.ai/api/search-image?query=macau%20cityscape%20aerial%20view%20with%20bridge%20connecting%20islands%20modern%20transportation%20hub%20blue%20sky%20summer%20day%20travel%20concept%20clean%20bright%20photography%20warm%20natural%20light&width=800&height=600&seq=article-a5&orientation=landscape',
    tags: ['交通指南', '口岸', '穿梭巴士'],
  },
  {
    id: 'a6',
    slug: 'xin-pu-jing-she-shi-yu-le',
    title: '新葡京酒店设施全览：超越住宿的奢华体验',
    excerpt: '除了顶级客房，新葡京酒店的水疗中心、恒温泳池、健身中心和娱乐设施同样值得体验，带您发现酒店内的精彩世界。',
    content: `<p>新葡京酒店不仅提供顶级住宿体验，其丰富的配套设施更将您的澳门之旅提升至全新高度。从放松身心的水疗中心到激情澎湃的娱乐场，酒店内的每一项设施都经过精心设计。</p>
    <h2>水疗中心</h2>
    <p>荣获多项国际大奖的水疗中心占地超过2,000平方米，设有12间理疗室、桑拿房、蒸汽浴室和冰泉。推荐体验招牌"东方之旅"疗程，融合中式经络按摩与泰式拉伸技法，时长120分钟。</p>
    <h2>恒温泳池</h2>
    <p>25米室内恒温无边泳池常年保持28°C舒适水温，配备水中吧台和按摩池。透过落地玻璃窗可欣赏澳门城市天际线，是放松身心的理想场所。</p>
    <h2>健身中心</h2>
    <p>24小时开放的健身中心配备Technogym最新款器材，提供私人教练服务和瑜伽课程，满足不同运动需求的宾客。</p>`,
    category: '设施娱乐',
    date: '2026-06-28',
    author: '新葡京酒店康体部',
    imageUrl: 'https://readdy.ai/api/search-image?query=luxury%20hotel%20spa%20interior%20serene%20treatment%20room%20with%20candles%20and%20flowers%20soft%20warm%20lighting%20marble%20details%20tranquil%20atmosphere%20cream%20and%20gold%20tones%20relaxation%20concept&width=800&height=600&seq=article-a6&orientation=landscape',
    tags: ['设施', '水疗', '娱乐'],
  },
];

export const reviews: Review[] = [
  { id: 'r1', name: '张先生', platform: '携程', rating: 5, date: '2026-08-05', content: '入住新葡京的尊贵套房，体验超乎想象！从踏入大堂的那一刻起就被金碧辉煌的装潢震撼，管家服务无微不至，天巢法国餐厅的美食更是令人惊艳。强烈推荐！' },
  { id: 'r2', name: '李女士', platform: 'TripAdvisor', rating: 5, date: '2026-07-28', content: '这是我住过最奢华的酒店之一，海景套房视野无敌，私人露台上看日出是此行最美好的回忆。水疗中心的按摩师手法专业，让旅途疲惫一扫而空。' },
  { id: 'r3', name: '王先生', platform: 'Booking.com', rating: 5, date: '2026-07-20', content: '商务出行选择了行政客房，非常满意。行政酒廊的早餐和Happy Hour都很赞，地理位置极佳，去各大赌场和景点都步行可达。' },
  { id: 'r4', name: '陈女士', platform: '大众点评', rating: 5, date: '2026-07-15', content: '家庭出游选了家庭套房，孩子们特别喜欢专属游戏区，亲子设施非常贴心。自助餐厅品种丰富，全家人吃得非常开心！下次来澳门还会选择新葡京。' },
  { id: 'r5', name: '刘先生', platform: '小红书', rating: 5, date: '2026-07-08', content: '为庆祝结婚纪念日预订了总统套房，不得不说物超所值！私人影院看了一部老电影，专属SPA房做了情侣按摩，劳斯莱斯接送更是仪式感满满。' },
  { id: 'r6', name: '赵女士', platform: '携程', rating: 4, date: '2026-06-30', content: '酒店位置极佳，步行到大三巴只需15分钟。房间设施一流，唯一小遗憾是旺季入住人比较多，建议错峰出行。8餐厅的粤菜绝对是澳门一绝！' },
];

export interface CategoryTab {
  id: string;
  label: string;
  icon: string;
}

export const categoryTabs: CategoryTab[] = [
  { id: 'rooms', label: '房型选择', icon: 'ri-hotel-bed-line' },
  { id: 'dining', label: '餐厅美食', icon: 'ri-restaurant-line' },
  { id: 'facilities', label: '设施娱乐', icon: 'ri-building-line' },
  { id: 'transport', label: '周边交通', icon: 'ri-road-map-line' },
];

export interface TransportInfo {
  id: string;
  from: string;
  method: string;
  duration: string;
  cost: string;
  description: string;
}

export const transportOptions: TransportInfo[] = [
  { id: 't1', from: '澳门国际机场', method: '免费穿梭巴士', duration: '约15分钟', cost: '免费', description: '每30分钟一班，上车地点：机场到达厅出口' },
  { id: 't2', from: '港澳码头', method: '免费穿梭巴士', duration: '约8分钟', cost: '免费', description: '每20分钟一班，上车地点：码头出口左侧' },
  { id: 't3', from: '关闸口岸', method: '免费穿梭巴士', duration: '约12分钟', cost: '免费', description: '需提前预约，上车地点：关闸广场巴士站' },
  { id: 't4', from: '横琴口岸', method: '出租车', duration: '约25分钟', cost: 'HK$150-200', description: '建议预约酒店专车接送服务' },
  { id: 't5', from: '澳门国际机场', method: '出租车', duration: '约15分钟', cost: 'HK$80-100', description: '机场出租车站在到达厅外' },
];

export const aboutInfo = {
  brandName: '新葡京酒店',
  brandNameEn: 'Grand Lisboa Hotel',
  established: '2007年',
  address: '澳门半岛葡京路2-4号',
  phone: '+853 2828 3838',
  email: 'reservations@grandlisboa.com',
  description: '新葡京酒店是澳门最具标志性的豪华酒店之一，由澳门博彩股份有限公司投资兴建。酒店以其独特的莲花造型和金色外观成为澳门天际线最引人注目的地标。自2007年开业以来，新葡京酒店始终致力于为全球宾客提供极致奢华的下榻体验。',
  mission: '以卓越的品质和无微不至的服务，为每一位宾客打造超越期待的奢华体验，成为澳门乃至亚洲豪华酒店行业的标杆。',
  stats: [
    { label: '客房数量', value: '430+' },
    { label: '米其林星级', value: '6星' },
    { label: '开业年份', value: '2007' },
    { label: '员工人数', value: '2,000+' },
  ],
};